import { render, staticRenderFns } from "./SolicitacoesTabela.vue?vue&type=template&id=fa860bfe"
import script from "./SolicitacoesTabela.vue?vue&type=script&lang=js"
export * from "./SolicitacoesTabela.vue?vue&type=script&lang=js"
import style0 from "./SolicitacoesTabela.vue?vue&type=style&index=0&id=fa860bfe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports